import Close from '@mui/icons-material/Close';
import { IconButton, IconButtonProps } from '@mui/material';

export const NotificationCloseButton = (props: IconButtonProps) => (
  <IconButton color="info" size="small" aria-label="Close Notification" {...props}>
    <Close />
  </IconButton>
);
